import { createApi } from "@reduxjs/toolkit/query/react";
import type { SearchRetailersRequest, SearchRetailersResponse, ListRetailersResponse, ListRetailersRequest } from "../contracts";
import { baseQueryWithAuth } from "./api";

export const retailerApi = createApi({
    reducerPath: "retailerApi",
    baseQuery: baseQueryWithAuth,
    endpoints: builder => ({
        searchRetailers: builder.query<SearchRetailersResponse, SearchRetailersRequest>({
            query: body => ({
                url: "retailer/search",
                method: "POST",
                body
            })
        }),
        listRetailers: builder.query<ListRetailersResponse, ListRetailersRequest>({
            query: body => ({
                url: "retailer/list",
                method: "POST",
                body
            })
        })
    })
});

export const {
    useSearchRetailersQuery,
    useLazySearchRetailersQuery,
    useLazyListRetailersQuery,
    useListRetailersQuery
} = retailerApi;
